import React           from 'react';

import ReactDOM        from 'react-dom/client';

import { isDesktop   } from 'react-device-detect';

import App             from './App';



if (isDesktop) {
  window.addEventListener('beforeunload', (event) => {
    // Стандарт для большинства современных браузеров
    event.preventDefault(); 
    
    // Требуется для Chrome, чтобы диалог сработал
    event.returnValue = ''; 
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if (isDesktop && window.matchMedia('(display-mode: standalone)').matches)
{
  window.resizeTo(500, 900);

  window.addEventListener('resize', (ev) => {
    window.resizeTo(500, 900);
  });
}